import { PriceGridAction } from '../../reducers/price/actionNames'

export default function(startDate) {
  return {
    startDate,
    type: PriceGridAction.ManualChangeDate,
  }
}
